export const MAINTENANCE_MODE_TYPE = {
  DISABLED: 'disabled',
  INCIDENT: 'incident',
  SCHEDULED: 'scheduled',
} as const

export type MaintenanceModeType = ValueOf<typeof MAINTENANCE_MODE_TYPE>

/** Polling interval for Eppo maintenance flag (ms). */
export const MAINTENANCE_MODE_CHECK_INTERVAL = 30000
